<a [routerLink]="['..']" class="adap-link link-return">
  <mat-icon svgIcon="cvx-left"></mat-icon>
  global settings
</a>

<div class="group-container header">
  <div class="header-title">risk assessment</div>
  <button
    class="adap-btn-filled add-mandatory-check-template-button"
    type="button"
    (click)="addFocusAreaConfig()"
  >
    add focus area <mat-icon svgIcon="cvx-plus-circle"></mat-icon>
  </button>

  <app-risk-assessment-config-table
    (editFocusAreaConfig)="editFocusAreaConfig($event)"
    (deleteFocusAreaConfig)="deleteFocusAreaConfig($event)"
  >
  </app-risk-assessment-config-table>
</div>
